import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { register, startPeriodicUpdateChecks } from './utils/serviceWorkerRegistration';
import { setupTimezoneSimulation } from './utils/timezoneSimulator';
import ErrorBoundary from './components/ErrorBoundary';

// ========================================
// TIMEZONE SIMULATION FOR TESTING
// ========================================
// Simulate that the FRONTEND SERVER is running in New York timezone at 5:50 PM
// The client's browser is in São Paulo (GMT-3), which is 2 hours ahead
// setupTimezoneSimulation({
//   enabled: true, // Set to false to disable simulation
//   timezone: 'America/New_York', // GMT-5 (frontend server timezone)
//   year: 2025,
//   month: 11, // November
//   day: 18,
//   hour: 17, // 5:50 PM in New York
//   minute: 50,
//   second: 0,
// });
// ========================================

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);

register({
  onSuccess: () => {
    startPeriodicUpdateChecks();
  },
  onUpdate: (registration) => {
    if ((window as any).handleServiceWorkerUpdate) {
      (window as any).handleServiceWorkerUpdate(registration);
    }
  },
  onOfflineReady: () => {
  },
  onNeedRefresh: () => {
  }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
